<template>
<section>
    <v-slide-y-transition>
        <h1 v-show="transitionH" class="text-right text-sm-center mt-3 mt-xs-3 mt-md-0 mt-lg-0 text-h5 text-sm-h4 text-md-h2 text-lg-h2 font-weight-black">LISTA DE OINKS</h1>
    </v-slide-y-transition>
    <v-container class="mt-5">
        <v-row justify="center" align="center">
            <v-col cols="12">
                <v-slide-y-transition>
                    <v-card outlined v-show="transitionH" class="bg_none">
                        <v-sheet class="py-2 px-5 mx-auto" color="transparent" max-width="100%" tile>
                            <v-row align="center" justify="center">
                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <v-select :items="filterFields" v-model="form.type" @change="form.value = null; form.status = null;" dense hide-details label="Tipo de búsqueda" outlined></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="5" lg="5" v-if="form.type === 1 || form.type === 2">
                                    <v-text-field v-model="form.value" dense outlined label="Campo de búsqueda" clearable @click:clear="form.value = null" hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="5" lg="5" v-else>
                                    <v-select :items="statusFields" v-model="form.status" dense hide-details label="Tipo de estado" outlined></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2" lg="2">
                                    <v-btn color="primary" depressed @click="search()" :loading="loading" :disabled="loading" block>Buscar</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="2" lg="2">
                                    <v-btn color="success" depressed @click="clear()" :loading="loading" :disabled="loading" block>Reiniciar</v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-card>
                </v-slide-y-transition>
            </v-col>
            <v-col cols="12">
                <v-slide-y-reverse-transition>
                    <oinkcard v-if="result" :items="result" />
                </v-slide-y-reverse-transition>
            </v-col>
            <v-col cols="12" v-if="result">
                <div class="pagination" v-if="Math.ceil(pagination.total/pagination.per_page)>0">
                    <v-btn icon v-for="(item, index) in Math.ceil(pagination.total/pagination.per_page)" :key="index" x-large :class="{ success: ((index) === pagination.page)  }" @click="search(index)">{{index+1}}</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</section>
</template>

<script>
import OinkItemComponent from './OinkItem';
import ApiService from '../../libs/apiService';
export default {
    name: 'OinkList',
    components: {
        'oinkcard': OinkItemComponent
    },
    data() {
        return {
            transitionH: false,
            showData: false,
            filterFields: [{
                    text: 'Nombre o ubicación',
                    value: 1
                },
                {
                    text: 'Estado',
                    value: 3
                },
            ],
            statusFields: [{
                    text: 'Success',
                    value: 200
                },
                {
                    text: 'Warning',
                    value: 300
                },
                {
                    text: 'Error',
                    value: 500
                },
            ],
            form: {
                type: 1,
                value: null,
                status: null,
            },
            result: null,
            loading: false,
            pagination: {
                page: 0,
                per_page: 12,
                total: 0
            }
        }
    },
    methods: {
        clear() {
            this.form.value = null;
            this.form.status = null;
            this.form.type = 1;
            this.search();
        },
        search(page) {
            this.result = null;
            // /piggybank/dashboard/find/
            if (page !== undefined && page !== null) {
                this.pagination.page = page;
            } else {
                this.pagination.page = 0;
            }
            this.loading = true;
            const apiService = new ApiService();
            const req = {
                search_text: this.form.value,
                status_id: this.form.status,
                page: this.pagination.page,
                items_per_page: 12
            };
            apiService.post('/piggybank/dashboard/find/', req, true).then((res) => {
                this.loading = false;
                if (res) {
                    const data = JSON.parse(res);
                    this.pagination.total = data.count;
                    this.result = data.items;
                    console.log(this.result);
                }
            }).catch((err) => {
                this.result = [];
                this.pagination.total = 0;
                this.loading = false;
                console.log(err);
            });
            return null
        }
    },
    mounted() {
        setTimeout(() => {
            this.transitionH = true
            this.showData = true
            this.search()
        }, 500);
    }
}
</script>
